"use strict";

var _photographyClientLib = require("@wix/photography-client-lib");
var CartService = /*#__PURE__*/function () {
  function CartService(cartScope) {
    this.items = {};
    this.storageKey = "AS_cart_" + cartScope;
    try {
      this.isLocalStorage = localStorage;
    } catch (e) {}
    if (this.isLocalStorage) {
      var cartItemsStr = localStorage.getItem(this.storageKey);
      if (cartItemsStr) {
        this.items = JSON.parse(cartItemsStr);
      }
    }
  }
  var _proto = CartService.prototype;
  _proto.saveInLocalStorage = function saveInLocalStorage() {
    if (this.isLocalStorage) {
      localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    }
  };
  _proto.setItem = function setItem(key, value) {
    this.items[key] = value;
    this.saveInLocalStorage();
  };
  _proto.getItem = function getItem(key) {
    return this.items[key];
  };
  _proto.removeItem = function removeItem(key) {
    if (this.items[key]) {
      // eslint-disable-next-line fp/no-delete
      delete this.items[key];
      this.saveInLocalStorage();
    } else {
      console.warning("cartService - item " + key + " does not exists");
    }
  };
  _proto.getAllItems = function getAllItems() {
    return this.items;
  };
  return CartService;
}();
var scope = '';
if (_photographyClientLib.window.instanceId) {
  scope = _photographyClientLib.window.instanceId;
}
_photographyClientLib.window.cartService = new CartService(scope);